import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.sparePart}stockInInventory/delete/${COMMON_QUERY_PARAMS.STOCK_ITEM_ID}`;

export interface DeleteStockInInventoryCommandArgs {
  stockInInventoryId: string;
}

export default async function deleteStockInInventoryCommand(
  payload: DeleteStockInInventoryCommandArgs,
): Promise<BackResponse<boolean> | BackResponseFailure> {
  try {
    const response = await apiCall<BackResponse<boolean>>(
      ENDPOINT.replace(
        COMMON_QUERY_PARAMS.STOCK_ITEM_ID,
        payload.stockInInventoryId,
      ),
      {
        method: SUPPORTED_METHODS.DELETE,
      },
    );

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
